import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';

import axios from "axios";
import {Button, Card, Col, Row} from "react-bootstrap";
import TimePicker from 'react-bootstrap-time-picker';


export const ClientSessionReadOnly = (props: { cookieQr: string }) => {

    const [sessionDetails, setSessionDetails] = useState<Array<any>>([])

    useEffect(() => {
        if (props.cookieQr) {
            axios.get('/api/backend/client/config/fetch/' + props.cookieQr)
                .then(resp => {
                    if (resp.data) {
                        setSessionDetails(JSON.parse(resp.data.sessions))
                    }
                })
                .catch(err => {
                    setSessionDetails([])
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
                .finally(() => {
                })
        }
    }, [props.cookieQr])

    function getDaySessions(day: any) {
        return <>
            <div className="row  py-1">
                <div className="col col-12">
                    <div className="font-weight-bold text-info">{day.name}</div>
                </div>
            </div>
            <div className="row py-1 session">
                <div className="col col-12">
                    {day.sessions && (day.sessions as Array<any>).map(session => {
                        return <>
                            <div className="d-flex my-1">
                                <TimePicker value={session.startTime} disabled className="bg-white border-white"/>&nbsp;
                                <b className="align-self-center">to</b>
                                &nbsp;
                                <TimePicker value={session.endTime} disabled className="bg-white border-white text-right"/>&nbsp;
                            </div>
                        </>
                    })
                    }
                </div>
            </div>
        </>;
    }

    return (
        <>
            <Row>
                <Col>
                    {sessionDetails && sessionDetails.length > 0 &&
                        <Card className="border-secondary p-3">
                            < h5 className="text-secondary mb-4 text-decoration-underline">Timings</h5>

                            {sessionDetails.map(day => {
                                return getDaySessions(day)
                            })
                            }
                        </Card>
                    }

                </Col>
            </Row>
        </>
    );
};
